/* eslint-disable unused-imports/no-unused-vars */
import { FC, useMemo } from 'react'

import useTableScrollProductSimilar from '@hook/shared/use-table-product-similar-scroll'

import TableGridItem from './Item'
import TableGridItemExportFooter from './Item-export-footer'
import TableGridParametrizationIncrementItem from './parametrization/item-increment'

interface ITableGridBody {
  undoValue?: number
  updateIsGraphic?: (data: any) => void
  updatedFinalStorage?: (value: string, data: any) => void
}

const TableGridBody: FC<ITableGridBody> = ({
  undoValue,
  updateIsGraphic,
  updatedFinalStorage
}) => {
  const {
    data: rows,
    columns,
    actions,
    entity
  } = useTableScrollProductSimilar()

  const columnsCount = useMemo(() => {
    let count = 0

    for (const column of columns) {
      if (column.columns) {
        count += column.columns?.length
      } else {
        count += 1
      }
    }
    if (actions && actions.length > 0) {
      count++
    }
    return count
  }, [columns, actions])

  return (
    <tbody>
      {rows.data.length === 0 ? (
        <tr>
          <td colSpan={columnsCount} align="center">
            Dados não encontrados
          </td>
        </tr>
      ) : (
        rows.data.map((row, key) => (
          <>
            {(() => {
              if (entity === 'parametrization-increment') {
                return (
                  <TableGridParametrizationIncrementItem
                    data={row}
                    key={`table-grid-${key + 1}`}
                    indexData={key}
                  />
                )
              } else if (entity === 'vendas-footer') {
                return (
                  <TableGridItemExportFooter
                    data={row}
                    key={`table-grid-${key + 1}`}
                    isLast={key === rows.data.length - 1}
                  />
                )
              } else {
                return (
                  <TableGridItem data={row} key={`table-grid-${key + 1}`} />
                )
              }
            })()}
          </>
        ))
      )}
    </tbody>
  )
}

export default TableGridBody
